import React from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import RghtnowMarketingHeader from "./RghtnowMarketingHeader";
import RghtnowMarketingFooter from "./RghtnowMarketingFooter";
import "./rghtnow-pages.css";
import "./legal-pages.css";

const infoPages = {
  "free-delivery": {
    title: "Free Delivery",
    intro:
      "Delivery benefits are shown clearly before checkout and may vary by market, store, distance, basket value, and promotion.",
    sections: [
      {
        title: "How Delivery Offers Work",
        text:
          "Eligible delivery offers are applied only when your selected store, address, order value, and product availability meet the current offer rules.",
      },
      {
        title: "Market Coverage",
        text:
          "RGHT NOW supports UAE and India locations. Your selected delivery location controls the stores, services, currency, and offers shown in the shopping flow.",
      },
    ],
  },
  "returns-policy": {
    title: "Returns Policy",
    intro:
      "Return and refund eligibility depends on item type, condition, merchant policy, delivery status, and applicable local rules.",
    sections: [
      {
        title: "Before Requesting a Return",
        text:
          "Keep the item, invoice, and packaging available for review. Perishable, used, damaged, customized, or hygiene-sensitive items may not be eligible unless defective.",
      },
      {
        title: "Refund Processing",
        text:
          "Approved refunds are processed through the original payment method or the applicable checkout method after merchant verification.",
      },
    ],
  },
  "help-center": {
    title: "Help Center",
    intro:
      "Need help with an order, address, payment, merchant, or delivery partner query? Start here and our support flow will guide you.",
    sections: [
      {
        title: "Orders and Deliveries",
        text:
          "Check your order status from My Orders. For delivery or item issues, keep your order details ready so support can identify the merchant and delivery timeline.",
      },
      {
        title: "Contact Support",
        text:
          "For account, merchant, or delivery partner questions, use the Contact Us page and the RGHT NOW team will respond through the available support channel.",
      },
    ],
    action: { to: "/contact-us", label: "Contact Us" },
  },
};

const SupportInfoPage = () => {
  const { pathname } = useLocation();
  const slug = pathname.replace(/^\/+/, "");
  const page = infoPages[slug];

  if (!page) {
    return <Navigate to="/help-center" replace />;
  }

  return (
    <div className="legal-page">
      <RghtnowMarketingHeader active="support" />
      <main className="legal-shell">
        <div className="container">
          <section className="terms-card">
            <h1>{page.title}</h1>
            <p>{page.intro}</p>
            {page.sections.map((section) => (
              <React.Fragment key={section.title}>
                <h4>{section.title}</h4>
                <p>{section.text}</p>
              </React.Fragment>
            ))}
            {page.action && (
              <p>
                <Link to={page.action.to}>{page.action.label}</Link>
              </p>
            )}
          </section>
        </div>
      </main>
      <RghtnowMarketingFooter />
    </div>
  );
};

export default SupportInfoPage;
